// extracted by mini-css-extract-plugin
module.exports = {"Icon":"components-Icon-___Icon__Icon___bp01p"};